import { Anulicense } from "../license";

const Banner = () => {
  return (
    <div className="container mx-auto">
      <div className="flex">
        {/* Left Side Image */}
        <div className="w-[100%]">
          <img
            className="h-full w-full object-cover"
            src={Anulicense.banner2}
            alt="img"
          />
        </div>

        {/* Right Side Images */}
        <div className="flex flex-col">
          <img
            className="h-1/2 w-full object-cover"
            src={Anulicense.banner1}
            alt="banner"
          />
          <img
            className="h-1/2 w-full object-cover"
            src={Anulicense.banner3}
            alt="banner"
          />
        </div>
      </div>
    </div>
  );
};

export default Banner;
